import { Platform } from '@angular/cdk/platform';
import { CloudinaryService } from '@shared/services/cloudinary/cloudinary.service';
import { ElementRef, OnInit, Renderer2, OnChanges, SimpleChanges } from '@angular/core';
import { CldSourceMediaSize } from './cld-picture.interface';
import { BreakpointsSize as bps, Breakpoint } from '@fuse/services/match-media.service';
import { Directive, Input } from '@angular/core';

@Directive({
  selector: '[cldresize]',
  standalone: true
})
export class CldResizeDirective implements OnInit, OnChanges {

  @Input()
  image: string;
  @Input()
  videoId: string;
  @Input()
  sms: CldSourceMediaSize;
  @Input()
  round: boolean;
  @Input()
  fallbackImage?: string;

  constructor(
    private readonly el: ElementRef,
    private renderer: Renderer2,
    private cloudinaryService: CloudinaryService,
    private platform: Platform
  ) {

  }
  ngOnInit(): void {
    if (!this.platform.isBrowser) {
      this.setAttributes();
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (this.platform.isBrowser) {
      this.setAttributes();
    }
  }

  private setAttributes(): void {
    // try {
      const { videoId, image, sms, round } = this;
      const url = videoId ? this.cloudinaryService.getVideoImageUrl(videoId, sms.w, sms.h, sms.resizeMode) :
        this.cloudinaryService.getImageUrl(image, sms.w, sms.h, sms.resizeMode, round);
      const el = this.el.nativeElement;
      if (el.tagName === 'SOURCE') {
        this.renderer.setAttribute(el, 'media', this.getMedia(this.sms.bp));
        this.renderer.setAttribute(el, 'srcset', `${url} ${this.sms.w}w`);
        this.renderer.setAttribute(el, 'width', `${this.sms.w}px`);
        this.renderer.setAttribute(el, 'height', this.sms.h ? `${this.sms.h}px` : 'auto');
      } else if (el.tagName === 'IMG') {
        this.renderer.setAttribute(el, 'src', url);
      } else {
        throw new Error(`CLD-RESIZE DIRECTIVE: No supported element: ${el.tagName}. Required image or source element.`);
      }
  }

  getMedia(bp: Breakpoint) {
    return  `(min-width: ${bps.find(b => b.bp === bp).minWidth}px)`;
  }

}
